import script from "./payoutSummaryTable.vue?vue&type=script&setup=true&lang=js"
export * from "./payoutSummaryTable.vue?vue&type=script&setup=true&lang=js"

import "./payoutSummaryTable.vue?vue&type=style&index=0&id=6b02a236&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b02a236"]])

export default __exports__